export var protoTimestamp = function (date) {
    return (date !== null && date !== void 0 ? date : new Date()).toISOString();
};
export var isIOSMobile = function () {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
export var interpolate = function (p) {
    return 0.5 - Math.cos(p * Math.PI) / 2;
};
